import LTR from "@brand-icons/ploom/search-default/search-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SearchDefaultIcon = iconFactory("SearchDefaultIcon", LTR);
